import InfiniteScroll from "react-infinite-scroll-component";
import Table from "../table/table";
import BlockComponent from "../block/block";

const InfinityTable = ({
  data,
  fetchData,
  hasMore,
  tableColumns,
  isLoading = false,
  onHandleRowClick,
  before,
  after,
  onChange,
  rowSelection,
  rowTestID,
  containerRef,
  // Pixels of page chrome sitting ABOVE this table, beyond the 88px header the
  // height below has always assumed. A page that renders anything between the
  // header and the table must pass its measured height, or the table's scroll
  // container runs past the bottom of the viewport - and since the page shell
  // clips with overflow:hidden, whatever falls off is unreachable rather than
  // merely off-screen. Defaults to 0, so the 29 pages that stack nothing above
  // their table behave exactly as before (LF360-1917).
  heightOffset = 0,
}) => {
  return (
    <InfiniteScroll
      dataLength={data?.length || 0}
      next={fetchData}
      hasMore={!!hasMore}
      height={Math.max(240, window.innerHeight - 88 - heightOffset)}
    >
      <BlockComponent ref={containerRef} fixThead>
        {before}
        <Table
          columns={tableColumns}
          data={data}
          isLoading={isLoading}
          onHandleRowClick={onHandleRowClick}
          onChange={onChange}
          rowSelection={rowSelection}
          rowTestID={rowTestID}
        />
        {after}
      </BlockComponent>
    </InfiniteScroll>
  );
};

export default InfinityTable;
